<template>
  <div id="contenedor-default-contrato-ejecucion">
    <!-- ToolBar -->
    <tool-bar
      v-on:nuevoReporte="registrarNuevoReporte"
      class="d-print-none">
    </tool-bar>
    <!-- Listado -->
    <listado
      class="d-print-none"
      :reportesFisicos="getContratoReportesFisicos">
    </listado>
    <!-- Registrar nuevo reporte fisicos -->
    <v-dialog
      v-if="mostrarVentanaRegistrarNuevoReporte"
      v-model="mostrarVentanaRegistrarNuevoReporte"
      fullscreen
      scrollable
      persistent>
      <v-card>
        <v-card-title>
          Registrar nuevo informe físico
          <v-chip
            v-if="getUltimoReporteFisico"
            class="ml-2">
            {{ ((getUltimoReporteFisico.numero || 0) + 1) }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.registrarNuevoInforme.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <nuevo
            :contrato="contrato"
            :ultimoReporteFisico="getUltimoReporteFisico"
            ref="registrarNuevoInforme"
            @cerrar="mostrarVentanaRegistrarNuevoReporte = !mostrarVentanaRegistrarNuevoReporte"
            @formularioValido="setRegistrarFormularioValido">
          </nuevo>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click.prevent="$refs.registrarNuevoInforme.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click.prevent="$refs.registrarNuevoInforme.mixGuardar()"
            :disabled="!registrarFormularioValido"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Editar Reporte Fisico -->
    <v-dialog
      v-if="mostrarEditarReporteFisico"
      v-model="mostrarEditarReporteFisico"
      fullscreen
      scrollable
      persistent>
      <v-card>
        <v-card-title>
          Editar informe físico
          <v-chip
            v-if="esteReporteFisico"
            class="ml-2">
            {{ esteReporteFisico.numero }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.editarInforme.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <editar-reporte
            :contrato="contrato"
            :ultimoReporteFisico="getUltimoReporteFisico"
            ref="editarInforme"
            @cerrar="mostrarEditarReporteFisico = !mostrarEditarReporteFisico"
            @formularioValido="setRegistrarFormularioValido">
          </editar-reporte>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click.prevent="$refs.editarInforme.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click.prevent="$refs.editarInforme.mixActualizar()"
            :disabled="!registrarFormularioValido"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Mostrar Reporte Fisico -->
    <v-dialog
      v-if="esteReporteFisico"
      v-model="mostrarReporteFisico"
      fullscreen
      hide-overlay
      scrollable
      transition="dialog-bottom-transition">
      <v-card
        color="#F2F6FF"
        class="d-print-none">
        <v-card-title>
          <span
            class="text-uppercase">
            Reporte de avance fisico {{ esteReporteFisico.numero }}
          </span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrarVentanaVerReporteFisico">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ver-reporte
            :reporte-fisico="esteReporteFisico">
          </ver-reporte>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined>
            <v-icon
              left>
              fa-print
            </v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Para imprimir reporte -->
    <print>
      <template
        v-slot:header>
        <h1>Titulo</h1>
      </template>
      <template
        v-slot:contenido>
        <ver-reporte
          v-if="esteReporteFisico"
            :reporte-fisico="esteReporteFisico">
          </ver-reporte>
      </template>
    </print>
    <v-dialog
        v-if="esteReporteFisico"
        v-model="mostrarEliminarReporteFisico"
        width="500">
        <eliminar-reporte-fisico
          :reporteFisicoEliminar="esteReporteFisico"
          v-on:cerrar="cerrarEliminarReporte"
        />
    </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import EliminarReporteFisico from '@/components/administracion/ejecucion/reportes/Eliminar.vue';
import VerReporte from './reporte/Main.vue';
import ToolBar from '../ToolBar.vue';
import Listado from './listado/Main.vue';
import Print from '@/components/Print.vue';
import Nuevo from '@/components/administracion/ejecucion/reportes/nuevo/Main.vue';
import EditarReporte from '@/components/administracion/ejecucion/reportes/editar/Main.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'MainContratoEjecucionReportes',
  components: {
    EliminarReporteFisico,
    ToolBar,
    Listado,
    VerReporte,
    Print,
    Nuevo,
    EditarReporte,
    CustomButton,
  },
  data() {
    return {
      mostrar: false,
      mostrarVentanaRegistrarNuevoReporte: false,
      mostrarEditarReporteFisico: false,
      mostrarEliminarReporteFisico: false,
      mostrarReporteFisico: false,
      esteReporteFisico: null,
      registrarFormularioValido: false,
      // reporteKey: Date.now(),
    };
  },
  apollo: {
    contratoReportesFisicos: {
      query: CONTRATO_REPORTES_FISICOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('ver-reporte-fisico', (reporte) => {
      this.mostrarReporteFisico = true;
      this.esteReporteFisico = reporte;
    });
    eventBus.$on('editar-reporte-fisico', (reporte) => {
      this.mostrarEditarReporteFisico = true;
      this.esteReporteFisico = reporte;
    });
    eventBus.$on('eliminar-reporte-fisico', (reporte) => {
      this.mostrarEliminarReporteFisico = true;
      this.esteReporteFisico = reporte;
    });
  },
  methods: {
    setRegistrarFormularioValido(valor) {
      this.registrarFormularioValido = valor;
    },
    registrarNuevoReporte() {
      this.mostrarVentanaRegistrarNuevoReporte = true;
    },
    cerrarRegistrarNuevoReporte() {
      this.mostrarVentanaRegistrarNuevoReporte = false;
      this.registrarFormularioValido = false;
    },
    cerrarEditarReporte() {
      this.esteReporteFisico = null;
      this.mostrarEditarReporteFisico = false;
    },
    cerrarVentanaVerReporteFisico() {
      this.esteReporteFisico = null;
      this.mostrarReporteFisico = !this.mostrarReporteFisico;
    },
    cerrarEliminarReporte() {
      this.mostrarEliminarReporteFisico = false;
    },
  },
  computed: {
    getContratoReportesFisicos() {
      if (!this.contratoReportesFisicos) return [];
      return [...this.contratoReportesFisicos].sort((a, b) => b.numero - a.numero);
    },
    getUltimoReporteFisico() {
      const [ultimo] = this.getContratoReportesFisicos;
      if (!ultimo) return {};
      return ultimo;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
